import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';

const QRCodeContainer = styled.div<React.CSSProperties>`
  width: ${930 * Screen.widthRatio}px;
  height: ${221 * Screen.widthRatio}px;
  margin-top: ${55 * Screen.widthRatio}px;
  line-height: ${216 * Screen.widthRatio}px;
  background: ${Colors['light']};
`;

export default QRCodeContainer;
